import { render, staticRenderFns } from "./virtual-tree.vue?vue&type=template&id=622351d2&scoped=true";
import script from "./virtual-tree.vue?vue&type=script&lang=js";
export * from "./virtual-tree.vue?vue&type=script&lang=js";
import style0 from "./virtual-tree.vue?vue&type=style&index=0&id=622351d2&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "622351d2", null);
export default component.exports;